"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCostsResult = exports.validateCostsResultAICost = exports.validateCostsResultRequestAICost = exports.validateCostsResultRequest = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateCostsResultRequest = (0, validation_1.properties)({
    startDate: (0, validation_1.text)(),
    endDate: (0, validation_1.text)(),
});
exports.validateCostsResultRequestAICost = (0, validation_1.properties)({
    model: (0, validation_1.text)(),
    unit: (0, validation_1.integer)(),
    unitCost: (0, validation_1.integer)(),
});
exports.validateCostsResultAICost = (0, validation_1.properties)({
    userId: (0, validation_1.text)(),
    timestamp: (0, validation_1.text)(),
    event: (0, validation_1.text)(),
    details: (0, validation_1.array)(exports.validateCostsResultRequestAICost),
    cost: (0, validation_1.integer)(),
});
exports.validateCostsResult = (0, validation_1.properties)({
    request: exports.validateCostsResultRequest,
    costs: (0, validation_1.array)(exports.validateCostsResultAICost),
});
//# sourceMappingURL=CostsResult.js.map